import React from 'react'
import './BadgingNotification.scss'
import Button from '../../blocks/Button';

export default function BadgingNotification(props) {
  const {children, buttonText="", onClickButton, waiting} = props;
  return (
    <div className='badging-notification-container'>
      <div className='badging-notification-text'>{children}</div>
      {onClickButton && <Button style={{marginRight: 0}} onClick={onClickButton} waiting={waiting}>{buttonText}</Button>}
    </div>
  )
}
